exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-f6cc2580]{display:inline-block;padding:10px;font-size:16px}a.white[data-v-f6cc2580]{color:#fff}a.blank[data-v-f6cc2580]{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6cc2580","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Phone/Phone.vue
// module id = mcAK
// module chunks = 18